import { inject, Injectable } from '@angular/core';
import { IRemoteError, ISeverityHandler, SeverityHandler, TSeverityCallback, TSeverityCode } from '@partners/errors';
import { NavigationService } from '@partners/navigation';
import { SettingsMap } from '@partners/settings';
import { EMPTY } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UploadDocumentSeverities extends SeverityHandler implements ISeverityHandler {
  override handlers: Map<TSeverityCode, TSeverityCallback>;
  private _navService = inject(NavigationService);

  constructor() {
    super();

    this.handlers = new Map<TSeverityCode, TSeverityCallback>()
        .set('W_0712', (error: IRemoteError) => {
          const { path } = SettingsMap.documentUploadAlert();
          this._navService.moveAny(`/${path}/${error.token}`);
          return EMPTY;
        })
        .set('W_0713', (error: IRemoteError) => {
          const { path } = SettingsMap.documentUploadAlert();
          this._navService.moveAny(`/${path}/${error.token}`);
          return EMPTY;
        })
        .set('W_0714', (error: IRemoteError) => {
          const { path } = SettingsMap.documentUploadAlert();
          this._navService.moveAny(`/${path}/${error.token}`);
          return EMPTY;
        }).set('W_0715', (error: IRemoteError) => {
          const { path } = SettingsMap.documentUploadAlert();
          this._navService.moveAny(`/${path}/${error.token}`);
          return EMPTY;
        }).set('W_0718', (error: IRemoteError) => {
          const { path } = SettingsMap.documentUploadAlert();
          this._navService.moveAny(`/${path}/${error.token}`);
          return EMPTY;
        }).set('W_0719', (error: IRemoteError) => {
          const { path } = SettingsMap.documentUploadAlert();
          this._navService.moveAny(`/${path}/${error.token}`);
          return EMPTY;
        }).set('W_0722', (error: IRemoteError) => {
          const { path } = SettingsMap.documentUploadAlert();
          this._navService.moveAny(`/${path}/${error.token}`);
          return EMPTY;
        }).set('W_0723', (error: IRemoteError) => {
          const { path } = SettingsMap.documentUploadAlert();
          this._navService.moveAny(`/${path}/${error.token}`);
          return EMPTY;
        }).set('W_0724', (error: IRemoteError) => {
          const { path } = SettingsMap.documentUploadAlert();
          this._navService.moveAny(`/${path}/${error.token}`);
          return EMPTY;
        }).set('W_0725', (error: IRemoteError) => {
          const { path } = SettingsMap.documentUploadAlert();
          this._navService.moveAny(`/${path}/${error.token}`);
          return EMPTY;
        }).set('W_0726', (error: IRemoteError) => {
          const { path } = SettingsMap.documentUploadAlert();
          this._navService.moveAny(`/${path}/${error.token}`);
          return EMPTY;
        }).set('W_0727', (error: IRemoteError) => {
          const { path } = SettingsMap.documentUploadAlert();
          this._navService.moveAny(`/${path}/${error.token}`);
          return EMPTY;
        }).set('W_0728', (error: IRemoteError) => {
          const { path } = SettingsMap.documentUploadAlert();
          this._navService.moveAny(`/${path}/${error.token}`);
          return EMPTY;
        });
  }
}
